import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Descriptions,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tag
} from "antd";
import React from "react";
import {sanitizeFieldName} from "../../util/methods";
import {Link} from "react-router-dom";
import * as moment from "moment-timezone/index";
import DocumentList from "../../components/DocumentList";
import ViewMeter from "./viewMeter";
import {forEach} from "underscore";

const {Panel} = Collapse;

class Process extends React.Component {
  state = {
    processedTasks: [],
    taskAction: [],
    taskRemark: [],
    finalVisible: false,
    documentData: null,
    checkListJobCard: null,
  };

  componentDidMount() {
    const {match, fetch, getManpowerList} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
      getManpowerList();
    }
  }

  changeTaskProcess = (task, action, remark) => {
    const {match} = this.props;
    // let processedTask = this.state.processedTasks;
    // if(task && action) {
    //   processedTask = processedTask.filter(pt => pt.task !== task);
    //   processedTask.push({
    //     task: task,
    //     isCompleted: action !== 'skipped',
    //     actionTaken: action,
    //     isSkipped: action === 'skipped',
    //   });
    //   this.setState({processedTasks: processedTask});
    // }
    if (task && action && match.params && match.params.id) {
      this.props.onSubmit(
        [
          {
            task: task,
            isCompleted: action !== "skipped",
            actionTaken: action,
            actionRemark: remark,
            isSkipped: action === "skipped"
          }
        ],
        match.params.id
      );
    }
  };

  updateChanges = () => {
    const {match} = this.props;
    // call api to process
    // console.log(this.state.processedTasks, match.params.id);
    if (match.params && match.params.id) {
      this.props.onSubmit(this.state.processedTasks, match.params.id);
    }
  };

  setTask = (taskId, index, e) => {
    // e.preventDefault();
    const remark = this.state.taskRemark;
    this.saveTask(taskId, index, {actionTaken: e.target.checked, remark: remark[index] || ''});
    const actions = this.state.taskAction;
    actions[index] = e.target.checked;
    this.setState({
      taskAction: actions
    })
  };

  setRemark = (index, e) => {
    // this.saveTask(task, 'a', e.target.value);
    const remark = this.state.taskRemark;
    remark[index] = e.target.value;
    this.setState({
      taskRemark: remark
    });
  };

  saveTask = (taskId, index, obj) => {
    const {match} = this.props;
    // console.log(obj)
    // console.log(task, this.state.taskAction[task], this.state.taskRemark[task]);
    // {task, actionTaken: this.state.taskAction[task], remark: e.target.value}
    if (match.params && match.params.id) {
      this.props.onSubmit({...obj, task: taskId, taskIndex: index}, match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    // if(nextProps && nextProps.data && this.props.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
    //   const tasks = nextProps.data && nextProps.data['tasks'] || [];
    //   const savedTasks = [];
    //   tasks.map(task => {
    //     savedTasks[task.task._id] = task.actionTaken;
    //   });
    //   this.setState({
    //     taskAction: savedTasks,
    //   })
    // }
    // console.log(nextProps.data)

    if (nextProps.data && nextProps.data.jobCard && !this.state.checkListJobCard) {
      // console.log('Setting JC')
      this.setState({
        checkListJobCard: nextProps.data.jobCard
      })
    }

    if (
      nextProps &&
      nextProps.data &&
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      const {isCompleted} = nextProps.data;
      // console.log(newPm, isCompleted);
      if (isCompleted) {
        this.setState({
          finalVisible: true
        });
      }
    }

    if (
      nextProps &&
      nextProps.isProcessDone &&
      nextProps.isProcessDone !== this.props.isProcessDone
    ) {
      this.setState({
        finalVisible: false
      });
    }

    if (
      nextProps &&
      nextProps.data &&
      nextProps.data.pm &&
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      const {data} = nextProps;
      const {asset, schedules, _id} = data.pm || {};
      if (asset && schedules && asset._id && schedules.length) {
        this.props.fetchLastProcessed(
          asset._id,
          schedules.map(si => si._id).toString(),
          _id
        );
      }
    }

    if (
      nextProps &&
      nextProps.data &&
      nextProps.data.pm &&
      JSON.stringify(nextProps.data.pm) !== JSON.stringify(this.props.data.pm)
    ) {
      const {tasks} = nextProps.data.pm || {};
      if (tasks && tasks.length) {
        const taskAction = [];
        const taskRemark = [];
        tasks.forEach((task, index) => {
          taskAction[index] = task.isCompleted;
          taskRemark[index] = task.remark || '';
        })
        this.setState({
          taskAction: taskAction,
          taskRemark: taskRemark
        })
      }
    }
  }

  handleProcessSubmit = e => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const {documentData} = this.state;
      if (documentData && documentData.length) {
        values.documents = documentData;
      }
      if (match.params && match.params.id) {
        this.props.process(values, match.params.id);
      }
    });
  };

  getDocumentData = data => {
    this.setState({documentData: data});
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      data,
      loading,
      filters,
      title,
      resource,
      form,
      identifiers,
      identifierData,
      lastProcessedResource
    } = this.props;
    const tasks = (data && data["pm"] && data["pm"]["tasks"]) || [];
    const {
      asset,
      complaint,
      createdBy,
      createdAt,
      schedules,
      hasProcessed,
      processedBy,
      processedOn
    } = data.pm || {};
    const cols = [
      {
        title: "Sl.",
        dataIndex: "sl",
        key: "sl",
        width: "30px",
        render: (_, __, index) => index + 1
      },
      {
        title: "Code",
        dataIndex: "taskCode",
        key: "taskCode",
        width: "200px",
        render: (_, record) =>
          `${record.task && record.task.taskCode} [${record.schedule &&
          record.schedule.toString()}]`
      },
      {
        title: "Name",
        dataIndex: "taskName",
        key: "taskName",
        width: "200px",
        render: (_, record) => record.task && record.task.taskName
      },
      {
        title: "Instruction",
        dataIndex: "instruction",
        key: "instruction",
        width: "150px",
        render: (_, record) => record && record.instruction
      },
      {
        title: (
          <>
            Action<h5>(Press Enter to save)</h5>
          </>
        ),
        dataIndex: "action",
        key: "action",
        width: "300px",
        render: (_, record, index) => (
          <div>
            <Row>
              <Col span={8}>
                <Checkbox
                  checked={
                    this.state.taskAction[index] !== undefined
                      ? this.state.taskAction[index]
                      : (record.actionTaken &&
                          record.actionTaken.toString() === "true") ||
                        false
                  }
                  onChange={e => this.setTask(record.task._id, index, e)}
                >
                  Done
                </Checkbox>
              </Col>
              <Col span={16}>
                <Input
                  placeholder={"Remarks"}
                  disabled={hasProcessed}
                  addonAfter={
                    <Icon
                      type={"check"}
                      style={{color: "green"}}
                      onClick={() =>
                        this.saveTask(record.task._id, index, {
                          remark: this.state.taskRemark[index],
                          actionTaken: this.state.taskAction[index],
                        })
                      }
                    />
                  }
                  value={this.state.taskRemark[index] !== undefined ? this.state.taskRemark[index] : (record.remark || "")}
                  onChange={e => this.setRemark(index, e)}
                  onPressEnter={() =>
                    this.saveTask(record.task._id, index, {
                      remark: this.state.taskRemark[index],
                      actionTaken: this.state.taskAction[index],
                    })
                  }
                />
              </Col>
            </Row>
          </div>
        )
      }
    ];
    return (
      <Card
        className={`gx-card-metrics`}
        title={`${title} ${sanitizeFieldName(resource)}`}
      >
        <Collapse
          bordered={false}
          defaultActiveKey={[]}
          expandIconPosition={"right"}
        >
          <Panel header={<h4>Service Info</h4>} key="1">
            <Descriptions title="" bordered>
              <Descriptions.Item label="Asset">
                <Link
                  target={"_blank"}
                  to={`/asset/history-report/${asset && asset._id}`}
                >
                  {(asset && asset.assetCode) || "-"}
                </Link>
              </Descriptions.Item>
              <Descriptions.Item label="Location">
                {(asset && asset.location && asset.location.name) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Sub Location">
                {(asset && asset.client && asset.client.name) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Alt No ">
                {(asset && asset.altName) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Service Identifier">
                {schedules &&
                  schedules.map((si, inx) => (
                    <>
                      {inx > 0 ? <br/> : null}
                      <Link
                        key={`sch-${inx}`}
                        target={"_blank"}
                        to={`/pmschedule/edit/${si && si._id}`}
                      >
                        {(si && si.serviceIdentifierName) || "-"} (
                        {(si && si.serviceIdentifierNo) || "-"})
                      </Link>
                    </>
                  ))}
              </Descriptions.Item>
              {/*<Descriptions.Item label="Complaint"><Link target={'_blank'}*/}
              {/*to={`/complaint/edit/${complaint && complaint._id}`}>{complaint && complaint.complaintNo || '-'}</Link></Descriptions.Item>*/}
              <Descriptions.Item label="JobCard">
                <Link
                  target={"_blank"}
                  to={`/job-card/report/${this.state.checkListJobCard && this.state.checkListJobCard._id}`}
                >
                  {(this.state.checkListJobCard && this.state.checkListJobCard.jobCardNo) || "-"}
                </Link>
              </Descriptions.Item>
              <Descriptions.Item label="Created On">
                {createdAt && moment(createdAt).format("DD-MM-YYYY")}
              </Descriptions.Item>
              <Descriptions.Item label="Created By">
                {(createdBy && createdBy.name) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Processed">
                {hasProcessed ? (
                  <Tag color="blue">Yes</Tag>
                ) : (
                  <Tag color="tomato">No</Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="Processed On">
                {processedOn && moment(processedOn || "-").format("DD-MM-YYYY")}
              </Descriptions.Item>
              <Descriptions.Item label="Processed By">
                {(processedBy && processedBy.name) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Service Person">
                {(data && data["pm"] && data["pm"]["servicePerson"]) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Supervisor Name">
                {(data && data["pm"] && data["pm"]["supervisorName"]) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Action">
                <Button
                  type="primary"
                  disabled={!(data && data["pm"] && data["pm"]["hasProcessed"])}
                >
                  <Link
                    target="_blank"
                    to={`../print/${data && data["pm"] && data["pm"]._id}`}
                  >
                    Print/Download
                  </Link>
                </Button>
              </Descriptions.Item>
              <Descriptions.Item label="Code">
                {(data && data["pm"] && data["pm"].code) || "-"}
              </Descriptions.Item>
            </Descriptions>
          </Panel>
        </Collapse>
        <Collapse
          bordered={false}
          defaultActiveKey={[]}
          expandIconPosition={"right"}
        >
          <Panel header={<h4>Meter Reading</h4>} key="1">
            <ViewMeter
              data={data}
              lastProcessedResource={lastProcessedResource}
            />
          </Panel>
        </Collapse>
        <Collapse
          bordered={false}
          defaultActiveKey={["1"]}
          expandIconPosition={"right"}
        >
          <Panel header={<span><h3>Checklist</h3> <Icon type="loading"
                                                        style={{
                                                          width: '50px',
                                                          float: 'right',
                                                          marginTop: '-20px',
                                                          display: loading ? 'block' : 'none'
                                                        }}/></span>}
                 key="1">
            <Table
              size={"small"}
              bordered
              scroll={{x: true}}
              pagination={false}
              dataSource={tasks}
              columns={cols}
              rowKey={(record, index) => `${record.task._id}_${index}`}
            />
            <br/>
          </Panel>
        </Collapse>
        <Modal
          visible={this.state.finalVisible}
          title="Confirm process the task sheet!"
          onCancel={() => this.setState({finalVisible: false})}
          footer={false}
        >
          <>
            <h4>
              All tasks were completed, do you want to process this sheet now?
            </h4>
            <Form onSubmit={this.handleProcessSubmit} className="login-form">
              <Form.Item>
                {getFieldDecorator("servicePerson", {
                  rules: [
                    {
                      required: true,
                      message: "Service Person name is required!"
                    }
                  ]
                })(
                  <Select
                    showSearch
                    required
                    placeholder="Enter Service Person Name"
                    filterOption={(input, option) => {
                      return (
                        (option.props.value + "")
                          .toLowerCase()
                          .indexOf((input + "").toLowerCase()) >= 0
                      );
                    }}
                  >
                    {this.props.manpowerList.map(manpower => (
                      <Select.Option key={manpower._id} value={manpower.name}>
                        {manpower.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator("supervisorName", {
                  rules: [
                    {required: true, message: "Supervisor name is required!"}
                  ]
                })(
                  <Select
                    showSearch
                    required
                    placeholder="Enter Service Supervisor Name"
                    filterOption={(input, option) => {
                      return (
                        (option.props.value + "")
                          .toLowerCase()
                          .indexOf((input + "").toLowerCase()) >= 0
                      );
                    }}
                  >
                    {this.props.manpowerList.map(manpower => (
                      <Select.Option key={manpower._id} value={manpower.name}>
                        {manpower.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <DocumentList
                match={this.props.match}
                history={this.props.history}
                key={"documents"}
                item={filters["documents"]}
                form={form}
                data={data["documents"]}
                subDocumentFilters={this.props.subDocumentFilters}
                getDocumentData={this.getDocumentData}
              />

              <Form.Item>
                <Button
                  type="primary"
                  className="gx-mb-0"
                  htmlType="submit"
                  loading={loading}
                >
                  Yes, Complete the Process
                </Button>
              </Form.Item>
            </Form>
          </>
        </Modal>
        {/*<Button type="primary" className="gx-mb-0" htmlType="button" onClick={this.updateChanges}>*/}
        {/*Update Changes*/}
        {/*</Button>*/}
      </Card>
    );
  }
}

const ProcessForm = Form.create({
  name: "global_state",
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  }
})(Process);

export default ProcessForm;
